<div class="h-full w-full">
    <div class="p-2 border-b border-gray-300 flex justify-between">
        <div class="primary-font font-bold text-2xl text-gray-900 flex items-center pl-2">
            {{"placeholder.title.add_service_task" | translate}}
        </div>
        <div class="flex space-x-4">
            
            <button type="button" mat-icon-button (click)="closeDrawer()">
                <em class="ti ti-x text-gray-900 text-xl"></em>
            </button>
        </div>
    </div>
    <div class="w-full flex flex-col space-y">
        <div class="flex justify-between">
            <div class="flex-1 flex items-center justify-between px-2 mx-2 w-full">
                <div class="max-w-md w-full">
                <label for="search" class="sr-only">{{'text.search' | translate}}</label>
                <div class="relative">
                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <!-- Heroicon name: solid/search -->
                        <em class="ti ti-search"></em>
                    </div>
                    <input type="text" id="search" name="search" [(ngModel)]="search" (keyup.enter)="allTasks=[];currentPage = 1;getServiceTask()" class="text-base block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:border-indigo-500" placeholder="{{'text.search' | translate}}" autocomplete="off">
                    <button mat-icon-button *ngIf="search?.length" (click)="clearSearch()" class="mat-focus-indicator min-w-3 min-h-3 min-w 3 h-8 w-8 mat-icon-button mat-button-base absolute inset-y-0 right-0 mr-2" style="margin-top: 0.2rem;">
                        <em class="ti ti-x close-mark cursor-pointer text-black text-xl"></em>
                    </button>
                </div>
                </div>
            </div>
            <mat-paginator class="ml-auto line-item-paginate" [length]="totalRecords"
                        [pageSize]="count" [pageIndex]="currentPage - 1" [hidePageSize]="true"
                        (page)="onPageItemEvent($event)">
            </mat-paginator>
        </div>
        <div class="h-1" *ngIf="!allTasks?.length">
            <mat-progress-bar mode="indeterminate" *ngIf="!loaded"></mat-progress-bar>
        </div>
        <div class="service-task-container flex justify-center items-center"  *ngIf="!allTasks?.length">
            <p>{{'text.empty_service_tasks' | translate}}</p>
        </div>
        <div class="flex flex-col flex-auto border border-t border-gray-200 hover-stripped zuper-scrollbar" *ngIf="allTasks?.length">
            <table mat-table [dataSource]="allTasks" aria-describedby="jobDetails">
                <!-- No Column -->
                <ng-container matColumnDef="checkbox">
                    <th mat-header-cell *matHeaderCellDef class="pr-2">  </th>
                    <td class="text-base max-w-1/12 pr-2 py-3" mat-cell *matCellDef="let element; let i = index"> 
                        <input type="checkbox" [checked]="getTaskValue(element)" (change)="toggleServiceTask(element)" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 cursor-pointer rounded">
                    </td>
                </ng-container>
            
                <!-- Service Task -->
                <ng-container matColumnDef="service_task">
                    <th mat-header-cell *matHeaderCellDef class="pl-6 pr-2"> {{"label.service_task" | translate}} </th>
                    <td class="text-base w-2/12 pl-6 pr-2 py-3 font-semibold cursor-pointer" (click)="toggleServiceTask(element)" mat-cell *matCellDef="let element; let index = index">
                        {{element?.service_task_title}}
                    </td>
                </ng-container>

                <!-- Description -->
                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef class="px-2"> {{"description" | translate}} </th>
                    <td class="text-base w-3/12 px-2 py-3" mat-cell *matCellDef="let element"> 
                      <p class="w-48 text-ellipsis truncate overflow-hidden">
                          {{element?.service_task_description}}
                      </p> 
                    </td>
                </ng-container>

                <!-- Inspection Form -->
                <ng-container matColumnDef="inspection_form">
                    <th mat-header-cell *matHeaderCellDef class="px-2"> {{"label.inspection_form" | translate}} </th>
                    <td class="text-base w-4/12 px-2 py-3" mat-cell *matCellDef="let element">
                        <p class="w-48 text-ellipsis truncate overflow-hidden">
                            {{element?.inspection_form?.asset_form_name}}
                        </p>
                    </td>
                </ng-container>
            
                <!-- Estimated Duration -->
                <ng-container matColumnDef="estimated_duration">
                    <th mat-header-cell *matHeaderCellDef class="px-2"> {{"label.estimated_duration" | translate}}</th>
                    <td class="text-base w-2/12 px-4 py-3" mat-cell *matCellDef="let element">
                        <span *ngIf="element?.estimated_duration?.days">{{element?.estimated_duration?.days}}d</span>
                        <span *ngIf="element?.estimated_duration?.hours"> {{element?.estimated_duration?.hours}}h</span>
                        <span *ngIf="element?.estimated_duration?.minutes"> {{element?.estimated_duration?.minutes}}m</span>
                    </td>
                </ng-container>
                    
                <tr mat-header-row class="bg-gray-50" *matHeaderRowDef="lineItemsDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: lineItemsDisplayedColumns;"></tr>
            </table>
        </div>
    </div>
    <div class="text-right zuper-dialog-footer pb-3">
        <button type="button" (click)="closeDrawer()" class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none mr-2">{{"cancel.text" | translate}}</button>
        <button type="button" (click)="addTask()" class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary focus:outline-none">{{"add.text" | translate}}</button>
    </div>
</div>